<template>
  <div class="card-panel">
    <div class="center white-text">
      <h4>{{ displayTitle }}</h4>
    </div>
    <h5>Instrucciones</h5>
    <ul>
      <li>Resuelve con naturalidad y rapidez</li>
      <li>Resolverás {{ reactivesLength }} preguntas</li>
      <li>Al concluir podrás poner tus recomendaciones o sugerencias</li>
      <li>La escala de calificación es la siguiente</li>

      <div>
        <button class="btn indigo waves-effect waves-light btn-instruction">
          1 En Desacuerdo
        </button>
        <button class="btn indigo waves-effect waves-light btn-instruction">
          2 Parcialmente de Acuerdo
        </button>
        <button class="btn indigo waves-effect waves-light btn-instruction">
          3 De Acuerdo
        </button>
        <button class="btn indigo waves-effect waves-light btn-instruction">
          4 Muy de Acuerdo
        </button>
        <button class="btn indigo waves-effect waves-light btn-instruction">
          5 Totalmente de Acuerdo
        </button>
      </div>
    </ul>
    <div class="right-align">
      <button @click="$emit('nextStep')" class="btn indigo">
        <i class="material-icons left">send</i>Continuar
      </button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      frequency: "",
      qualification: "",
      displayTitle: this.urlToString(this.$route.params.campain).toUpperCase(),
    };
  },
  computed: {
    ...mapState(["evaluator", "thisCampain", "reactivesLength"]),
  },
  methods: {
    urlToString(string) {
      return string.replace(/-/g, " ");
    },
    confirmAndNext() {
      this.updateFrequency(this.frequency);
      this.updateQualification(this.qualification);
      this.$emit("nextStep");
    },
    ...mapMutations(["updateFrequency", "updateQualification"]),
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});
  },
};
</script>

<style scoped>
.btn-instruction {
  text-align: left !important;
  width: 50%;
  margin-bottom: 5px;
  padding-left: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire/questionnaireSteps/instructions.vue